import {
  BookOutlined,
  ContainerOutlined,
  CopyOutlined,
  DiffOutlined,
  DotChartOutlined,
  FilePdfOutlined,
  FolderOpenOutlined,
  SaveOutlined,
  SnippetsOutlined,
} from "@ant-design/icons";
import { Col, Divider, Row } from "antd";
import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { useClient } from "../../Context/ClientContext";
import { useTheme } from "../../Context/ThemeContext";
import { CompanyGSTTypes } from "../../../Types/CommonConstants";
import { useUser } from "../../../Context/UserContext";
// import { IAccessSettings, Report_Type } from "../../../../src/Types/CommonTypes";
import { IAccessSettings } from "../../../Types/CommonTypes";
import { findUserOnlyOnePremission } from "../Users/Roles/UserSecurityFind";

const Reports = () => {
  const { currentClient, companySettings } = useClient();
  const { accessSettings, clientSpecificRole } = useUser();
  const useAccessSettingsData: IAccessSettings = accessSettings();
  const navigate = useNavigate();
  const themeData: any = useTheme();

  const financialData = [
    findUserOnlyOnePremission(
      "Report.P&L.View",
      clientSpecificRole(),
      currentClient?.id!
    ) && {
      title: "Profit & Loss",
      description:
        "The Profit and loss (P&L) statement is a financial statement that summarizes the revenues, costs, and expenses incurred during a specified period.",
      icon: <SnippetsOutlined color={themeData?.themeData?.themeColor} />,
      link: `/books/clients/${currentClient?.id}/reports/profitAndLoss`,
    },
    findUserOnlyOnePremission(
      "Report.BalanceSheet.View",
      clientSpecificRole(),

      currentClient?.id!
    ) && {
      title: "Balance Sheet",
      description:
        "Balance sheet is a financial report that outlines a company's assets, liabilities, and shareholders' equity for a particular period of time.",
      icon: <CopyOutlined color={themeData?.themeData?.themeColor} />,
      link: `/books/clients/${currentClient?.id}/reports/BalanceSheet`,
    },
    findUserOnlyOnePremission(
      "Report.TrialBalance.View",
      clientSpecificRole(),

      currentClient?.id!
    ) && {
      title: "Trial Balance",
      description:
        "Trial balance is a summary of all the balances in the ledger account at the end of the accounting period.",
      icon: <ContainerOutlined color={themeData?.themeData?.themeColor} />,
      link: `/books/clients/${currentClient?.id}/reports/trialbalancenew`,
    },

    // {
    //   title: "Statement of Cashflow",
    //   description:
    //     "The cash flow statement is a financial statement that summarizes the movement of cash and cash equivalents that come in and go out of a company.",
    //   icon: <FilePdfTwoTone />,
    //   link: ``,
    // },
  ];

  const payablenReceivable = [
    findUserOnlyOnePremission(
      "Report.DebtorsAgeing.View",
      clientSpecificRole(),

      currentClient?.id!
    ) && {
      title: "Aged Debtors",
      description:
        "Aged debtors report is a totalled list of all outstanding sales invoices, minus any credit notes that have been issued to customers, and not yet refunded.",
      icon: <FolderOpenOutlined color={themeData?.themeData?.themeColor} />,
      link: `/books/clients/${currentClient?.id}/reports/ageing/debtors`,
      type: 0,
    },
    findUserOnlyOnePremission(
      "Report.CreditorsAgeing.View",
      clientSpecificRole(),

      currentClient?.id!
    ) && {
      title: "Aged Creditors",
      description:
        "Aged creditors report is a totalled list of all the purchase bills that have not been paid yet, minus any credit notes that have been issued to suppliers, and not yet refunded.",
      icon: <SaveOutlined color={themeData?.themeData?.themeColor} />,
      link: `/books/clients/${currentClient?.id}/reports/ageing/creditors`,
      type: 1,
    },

    findUserOnlyOnePremission(
      "Report.CustomerOutstanding.View",
      clientSpecificRole(),

      currentClient?.id!
    ) && {
      title: "Customer Outstanding",
      description:
        "The customer outstanding list shows the customers who owe your company, how much they owe, and how long it has been since they were sent an invoice for payment.",
      icon: <FolderOpenOutlined color={themeData?.themeData?.themeColor} />,
      link: `/books/clients/${currentClient?.id}/reports/partyOutstanding/customer`,
      type: 0,
    },
    findUserOnlyOnePremission(
      "Report.SupplierOutstanding.View",
      clientSpecificRole(),

      currentClient?.id!
    ) && {
      title: "Supplier Outstanding",
      description:
        "The supplier outstanding report gives details of all the suppliers balances during the period.",
      icon: <DotChartOutlined color={themeData?.themeData?.themeColor} />,
      link: `/books/clients/${currentClient?.id}/reports/partyOutstanding/supplier`,
      type: 1,
    },
  ];

  const general = [
    findUserOnlyOnePremission(
      "Report.GeneralLedger.View",
      clientSpecificRole(),
      currentClient?.id!
    ) && {
      title: "General Ledger",
      description:
        "General ledger is a set of numbered billing a business uses to keep track of its financial transactions and to prepare financial reports.",
      icon: <DiffOutlined color={themeData?.themeData?.themeColor} />,
      link: `/books/clients/${currentClient?.id}/reports/generalLedger`,
    },
    // findUserOnlyOnePremission(
    //   "Report.FixedAssets.View",
    //   clientSpecificRole(),

    //   currentClient?.id!
    // ) && {
    //   title: "Fixed Assest Register",
    //   description:
    //     "A fixed asset register is a detailed list of various assets that a business owns and is used to summarise both accounting and depreciation expenses.",
    //   icon: <BookOutlined color={themeData?.themeData?.themeColor} />,
    //   link: `/books/clients/${currentClient?.id}/reports/far`,
    // },
    findUserOnlyOnePremission(
      "Report.BankReconciliation.View",
      clientSpecificRole(),

      currentClient?.id!
    ) && {
      title: "Bank Reconciliation",
      description:
        "A bank reconciliation statement is the summary of the banking and business billing that reconciles a company's bank account with its financial record.",
      icon: <FilePdfOutlined color={themeData?.themeData?.themeColor} />,
      link: `/books/clients/${currentClient?.id}/reports/brsReports`,
    },
  ];

  const GSTReports = [
    findUserOnlyOnePremission(
      "Report.GST.View",
      clientSpecificRole(),
      currentClient?.id!
    ) && {
      title: "GST Reports",
      description:
        "GST reports is the summary of all Sales and Purchases made during the designated period with GST received and paid on respectively. Difference in Sale and Purchase GST, if it is positive then it is payable else refundable.",
      icon: <FilePdfOutlined color={themeData?.themeData?.themeColor} />,
      link: `/books/clients/${currentClient?.id}/reports/GSTReports`,
    },
  ];

  const handleCardClick = (link: string) => {
    navigate(link);
  };

  return (
    <div>
      <h3
        style={{
          margin: "0px 0px 0px 0px",
          color: themeData?.themeData?.themeColor,
        }}
      >
        Reports
      </h3>
      <Divider style={{ margin: "10px 0px 0px 0px" }} />
      <div
        style={{
          maxHeight: "80vh",
          overflowY: "scroll",
          overflowX: "hidden",
          padding: "5px",
        }}
      >
        {/* {currentClient?.productModule !== Product_Module.Billing && ( */}
        {financialData?.find((x) => x !== false) && (
          <>
            <h3
              style={{
                margin: "10px 0px 10px 0px",
                color: themeData?.themeData?.themeColor,
              }}
            >
              Financial Reports
            </h3>
            <Row gutter={[20, 20]}>
              {financialData?.map(
                (data: any) =>
                  data && (
                    <Col xs={24} sm={12} md={8} lg={6} xl={6}>
                      <Link to={data?.link}>
                        <div className="report-card">
                          <Row>
                            <Col>
                              <span
                                style={{
                                  fontSize: "18px",
                                  padding: "5px 7px 0px 0px",
                                }}
                              >
                                {data?.icon}
                              </span>
                            </Col>
                            <Col>
                              <p
                                style={{
                                  fontSize: "15px",
                                  paddingTop: "1px",
                                  color: "black",
                                  fontWeight: "bold",
                                }}
                              >
                                {data?.title}
                              </p>
                            </Col>
                          </Row>

                          <p
                            style={{
                              paddingTop: "10px",
                              height: "100%",
                              lineHeight: "1.4rem",
                              color: "black",
                            }}
                          >
                            {data?.description}
                          </p>
                          <div>{data?.button}</div>
                        </div>
                      </Link>
                    </Col>
                  )
              )}
            </Row>
            {/* <Divider style={{ margin: "20px 0px 0px 0px" }} /> */}
          </>
        )}
        {/* )} */}
        {payablenReceivable?.find((x) => x !== false) && (
          <>
            <Divider style={{ margin: "20px 0px 0px 0px" }} />
            <h3
              style={{
                margin: "10px 0px 10px 0px",
                color: themeData?.themeData?.themeColor,
              }}
            >
              Payables and Receivables Reports
            </h3>
            <Row gutter={[20, 20]}>
              {payablenReceivable?.map(
                (data: any) =>
                  data && (
                    <Col
                      xs={24}
                      sm={12}
                      md={8}
                      lg={6}
                      xl={6}
                      style={{ height: "100%" }}
                    >
                      <Link to={data?.link}>
                        <div className="report-card">
                          <Row>
                            <Col>
                              <span
                                style={{
                                  fontSize: "18px",
                                  padding: "5px 7px 0px 0px",
                                }}
                              >
                                {data?.icon}
                              </span>
                            </Col>
                            <Col>
                              <p
                                style={{
                                  fontSize: "15px",
                                  paddingTop: "1px",
                                  color: "black",
                                  fontWeight: "bold",
                                }}
                              >
                                {data?.title}
                              </p>
                            </Col>
                          </Row>

                          <p
                            style={{
                              paddingTop: "10px",
                              height: "100%",
                              lineHeight: "1.4rem",
                              color: "black",
                            }}
                          >
                            {data?.description}
                          </p>
                          <div>{data?.button}</div>
                        </div>
                      </Link>
                    </Col>
                  )
              )}
            </Row>
          </>
        )}
        {/* {currentClient?.productModule !== Product_Module.Billing && ( */}
        {general.find((x) => x !== false) && (
          <>
            <Divider style={{ margin: "20px 0px 0px 0px" }} />
            <h3
              style={{
                margin: "10px 0px 10px 0px",
                color: themeData?.themeData?.themeColor,
              }}
            >
              General
            </h3>
            <Row gutter={[20, 20]}>
              {general?.map(
                (data: any) =>
                  data && (
                    <Col xs={24} sm={12} md={8} lg={6} xl={6}>
                      <Link to={data?.link}>
                        <div className="report-card">
                          <Row>
                            <Col>
                              <span
                                style={{
                                  fontSize: "18px",
                                  padding: "5px 7px 0px 0px",
                                }}
                              >
                                {data?.icon}
                              </span>
                            </Col>
                            <Col>
                              <p
                                style={{
                                  fontSize: "15px",
                                  paddingTop: "1px",
                                  color: "black",
                                  fontWeight: "bold",
                                }}
                              >
                                {data?.title}
                              </p>
                            </Col>
                          </Row>

                          <p
                            style={{
                              paddingTop: "10px",
                              height: "100%",
                              lineHeight: "1.4rem",
                              color: "black",
                            }}
                          >
                            {data?.description}
                          </p>
                          <div>{data?.button}</div>
                        </div>
                      </Link>
                    </Col>
                  )
              )}
            </Row>
          </>
        )}

        {/* )} */}
        {currentClient?.gstType === CompanyGSTTypes.Regular &&
          GSTReports.find((x) => x !== false) && (
            <>
              {" "}
              <Divider style={{ margin: "20px 0px 0px 0px" }} />
              <h3
                style={{
                  margin: "10px 0px 10px 0px",
                  color: themeData?.themeData?.themeColor,
                }}
              >
                GST Reports
              </h3>
              <Row gutter={[20, 20]}>
                {GSTReports?.map(
                  (data: any) =>
                    data && (
                      <Col
                        xs={24}
                        sm={12}
                        md={8}
                        lg={6}
                        xl={6}
                        style={{ height: "100%" }}
                      >
                        <Link to={data?.link}>
                          <div className="report-card">
                            <Row>
                              <Col>
                                <span
                                  style={{
                                    fontSize: "18px",
                                    padding: "5px 7px 0px 0px",
                                  }}
                                >
                                  {data?.icon}
                                </span>
                              </Col>
                              <Col>
                                <p
                                  style={{
                                    fontSize: "15px",
                                    paddingTop: "1px",
                                    color: "black",
                                    fontWeight: "bold",
                                  }}
                                >
                                  {data?.title}
                                </p>
                              </Col>
                            </Row>

                            <p
                              style={{
                                paddingTop: "10px",
                                height: "100%",
                                color: "black",
                                lineHeight: "1.4rem",
                              }}
                            >
                              {data?.description}
                            </p>
                            <div>{data?.button}</div>
                          </div>
                        </Link>
                      </Col>
                    )
                )}
              </Row>
            </>
          )}
      </div>
    </div>
  );
};

export default Reports;
